import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';


import { ColorsService } from './colors/colors.service';
import { CheckallDirective } from './directives/checkall/checkall.directive';
import { NowDirective } from './directives/now/now.directive';
import { ScrollableDirective } from './directives/scrollable/scrollable.directive';
import { ArticleApproversAvatarDirective } from './directives/approversavatar/articleapproversavatar.directive';
import { PlanApproversAvatarDirective } from './directives/approversavatar/planapproversavatar.directive';
import { ArticleStatusDirective } from './directives/approversavatar/articlestatus.directive';
import { PlanStatusDirective } from './directives/approversavatar/planstatus.directive';
import { SafeHtmlPipe } from './directives/approversavatar/planstatus.directive';
import { BongApproversDirective } from './directives/approversavatar/bongapprovers.directive';

import { Repository } from '../services/repository'
import { ToolDataService } from '../services/tooldata.service'
import { AuthorizationService } from '../services/authorization.service'
//import { ToasterModule, ToasterService } from 'angular2-toaster';
import { ToastModule } from '@syncfusion/ej2-angular-notifications';

import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { MaskedTextBoxModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
//import { NgxPhotoEditorModule } from "ngx-photo-editor";
import { TextBoxModule } from '@syncfusion/ej2-angular-inputs';

import { DatePickerModule, DateTimePickerModule, TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { CheckBoxModule, ButtonModule, SwitchModule, RadioButtonModule } from '@syncfusion/ej2-angular-buttons';
import { ScheduleAllModule, RecurrenceEditorAllModule } from '@syncfusion/ej2-angular-schedule';
import { FileManagerAllModule } from '@syncfusion/ej2-angular-filemanager';
import { GridAllModule } from '@syncfusion/ej2-angular-grids';
import { MultiSelectAllModule, DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { DropDownButtonModule, SplitButtonModule, ProgressButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { TreeGridAllModule } from '@syncfusion/ej2-angular-treegrid';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { ToolbarModule, TreeViewModule, ContextMenuModule, TabAllModule } from '@syncfusion/ej2-angular-navigations';
import { ListViewAllModule } from '@syncfusion/ej2-angular-lists';
import { NgxCurrencyModule } from "ngx-currency";
import { FileUploadModule } from 'ng2-file-upload';
import { CKEditorModule } from 'ckeditor4-angular';
import { NgxSpinnerModule } from "ngx-spinner";
//import { ImageEditorModule } from '@syncfusion/ej2-angular-image-editor';


import { quatrinhdaotaoComponent } from './components/daotao/quatrinhdaotao.component'
import { dkycanboeditComponent } from './components/tonghop/dkycanboedit.component'
import { filemanagerComponent } from './components/quantri/filemanager.component'
import { phanheeditComponent } from './components/quantri/phanheedit.component'
import { importeditComponent } from './components/tonghop/importedit.component'
import { danhmucchungeditComponent } from './components/danhmuc/danhmucchungedit.component'
import { loaicauhoieditComponent } from './components/danhmuc/loaicauhoiedit.component'
import { loaithieditComponent } from './components/danhmuc/loaithiedit.component'
import { choncanboeditComponent } from './components/tonghop/choncanboedit.component'
import { danhsachthieditComponent } from './components/danhmuc/danhsachthiedit.component'
import { ngayhethaneditComponent } from './components/danhmuc/ngayhethanedit.component'

import { choncauhoieditComponent } from './components/tonghop/choncauhoiedit.component'
// https://angular.io/styleguide#!#04-10
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    AccordionModule.forRoot(),
    AlertModule.forRoot(),
    ButtonsModule.forRoot(),
    CarouselModule.forRoot(),
    CollapseModule.forRoot(),
    DatepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    ProgressbarModule.forRoot(),
    RatingModule.forRoot(),
    TabsModule.forRoot(),
    TimepickerModule.forRoot(),
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    TypeaheadModule.forRoot(),
    ToastrModule.forRoot(),
    //ToasterModule,
    ToastModule,
    NgSelectModule,
    //NgxPhotoEditorModule,
    DialogModule,
    MultiSelectAllModule,
    DropDownListModule,
    MaskedTextBoxModule,
    DropDownButtonModule,
    TreeGridAllModule,
    RichTextEditorAllModule,
    ListViewAllModule,
    ToolbarModule,
    TreeViewModule,
    TabAllModule,
    CheckBoxModule,
    RadioButtonModule,
    ButtonModule,
    SwitchModule,
    TextBoxModule,
    CKEditorModule,
    //ImageEditorModule,
    NumericTextBoxModule,
 
    DatePickerModule,
    DateTimePickerModule,
   TimePickerModule,
    RecurrenceEditorAllModule,
    ScheduleAllModule,
    FileManagerAllModule,
    ContextMenuModule,
    GridAllModule,
    NgxCurrencyModule,
    FileUploadModule,
    UploaderModule,
    NgxSpinnerModule,
    
  ],
  providers: [ColorsService,
    Repository,
    ToolDataService,
    AuthorizationService,
    //ToasterService,
  ],
  declarations: [
   
    CheckallDirective,
    
    NowDirective,
    ScrollableDirective,
    ArticleApproversAvatarDirective,
    PlanApproversAvatarDirective,
    ArticleStatusDirective,
    PlanStatusDirective,
    SafeHtmlPipe,
    BongApproversDirective,
    //DynamicComponentDirective,

    quatrinhdaotaoComponent,
    dkycanboeditComponent,
    filemanagerComponent,
    phanheeditComponent,
    importeditComponent,
    danhmucchungeditComponent,
    loaicauhoieditComponent,
    loaithieditComponent,
    choncanboeditComponent,
    danhsachthieditComponent,
    ngayhethaneditComponent,
    choncauhoieditComponent,
  ],
  exports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    AccordionModule,
    AlertModule,
    ButtonsModule,
    CarouselModule,
    CollapseModule,
    DatepickerModule,
    BsDatepickerModule,
    BsDropdownModule,
    ModalModule,
    PaginationModule,
    ProgressbarModule,
    RatingModule,
    TabsModule,
    TimepickerModule,
    TooltipModule,
    PopoverModule,
    TypeaheadModule,
    ToastrModule,
    CKEditorModule,
    //ImageEditorModule,
    CheckallDirective,
    ContextMenuModule,
    NowDirective,
    ScrollableDirective,
    ArticleApproversAvatarDirective,
    PlanApproversAvatarDirective,
    ArticleStatusDirective,
    PlanStatusDirective,
    SafeHtmlPipe,
    BongApproversDirective,
    //DynamicComponentDirective,

    //ToasterModule,
    ToastModule,
    DialogModule,
    MultiSelectAllModule,
    DropDownListModule,
    MaskedTextBoxModule,
    DropDownButtonModule,
    TreeGridAllModule,
    RichTextEditorAllModule,
    ListViewAllModule,
    ToolbarModule,
    TreeViewModule,
    TabAllModule,
    CheckBoxModule,
    RadioButtonModule,
    SwitchModule,
    TextBoxModule,
    ButtonModule,
    NumericTextBoxModule,
    NgSelectModule,
   // NgxPhotoEditorModule,
    DatePickerModule,
    DateTimePickerModule,
   TimePickerModule,
    RecurrenceEditorAllModule,
    ScheduleAllModule,
    FileManagerAllModule,  
   
    GridAllModule,
    NgxCurrencyModule,
    //NgxTreeSelectModule,
    FileUploadModule,
    UploaderModule,
    NgxSpinnerModule,

    quatrinhdaotaoComponent,
    dkycanboeditComponent,
    filemanagerComponent,
    phanheeditComponent,
    importeditComponent,
    danhmucchungeditComponent,
    loaicauhoieditComponent,
    loaithieditComponent,
    choncanboeditComponent,
    danhsachthieditComponent,
    ngayhethaneditComponent,
    choncauhoieditComponent,
  ],
})

// https://github.com/ocombe/ng2-translate/issues/209
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
